import type { UserSearchResult } from "../../../experience-shell/queues";

function joinNames(given?: string | null, surname?: string | null): string | null {
    const parts = [given, surname].filter(
        (p): p is string => typeof p === "string" && p.length > 0,
    );
    return parts.length > 0 ? parts.join(" ") : null;
}

export function formatMemberPrimaryLabel(user: UserSearchResult): string {
    return (
        user.profile.displayName ??
        joinNames(user.profile.givenName, user.profile.surname) ??
        user.profile.userPrincipalName ??
        user.profile.email ??
        user.id
    );
}

export function formatMemberSecondaryLabel(user: UserSearchResult): string | null {
    return user.profile.email ?? user.profile.userPrincipalName ?? user.profile.jobTitle ?? null;
}

export function formatAddedAt(iso: string): string {
    try {
        const date = new Date(iso);
        return date.toLocaleDateString(undefined, {
            year: "numeric",
            month: "short",
            day: "numeric",
        });
    } catch {
        return iso;
    }
}
